import * as types from './constants';

const initialState = {
  open: false
};

const actions = {
  [types.OPEN_PRICING_MODAL]: state => ({ ...state, open: true }),
  [types.CLOSE_PRICING_MODAL]: state => ({ ...state, open: false })
};

const pricingModal = (state = initialState, action) => {
  const handler = actions[action.type];
  return handler ? handler(state, action) : state;
};

export default pricingModal;
